const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/hubs/hubs/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFilterConfig } from '@/Components/filterbar';
import type { ListChildType } from '@/Components/multiViewPicker/views';
import { requireUserCaps } from '@/Router';
import { HubsQuery, type Hubs_Pagination_Fragment$key, type Hubs_Query } from '@/graphql/queries/Hub.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
const HubsFilterConfig = createFilterConfig({
  routeId: '/dash/hubs/hubs/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true,
  visibility: true,
  author: true,
  order: true,
  date: true,
  hubTemplate: true,
  hubGroup: true,
  hubFilter: true
});
type HubsBodyProps = {
  isFallback?: boolean;
} & Partial<ReturnType<typeof usePaginationFragment<Hubs_Query, Hubs_Pagination_Fragment$key>>>;

// HubsBody is the main component for the Hubs page

export const Route = createFileRoute('/dash/hubs/hubs/')({
  validateSearch: HubsFilterConfig.filterSearchValidator,
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<Hubs_Query>(RelayEnvironment, HubsQuery, {
      first: 24,
      after: null,
      where: {
        statusIn: ['PUBLISH', 'HIDDEN', 'DRAFT', 'PENDING'],
        search: null
      }
    }, {
      fetchPolicy: 'store-or-network'
    });
  },
  beforeLoad() {
    requireUserCaps(['read_hub'], {
      to: '/dash/catalog'
    });
  }
});